import { mapGetters } from 'vuex'

export default {
  name: 'TextInfoModal',
  computed: {
    ...mapGetters({
      payload: 'popups/currentModalPayload',
    }),
  },
  created() {
    document.getElementById('html').classList.add('hide')
  },
}
